
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Gruppe 146","xmlns":"http://www.w3.org/2000/svg","width":"19.171","height":"26.695"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 119","d":"M6.08 9.276a5.305 5.305 0 117.013 0 6.306 6.306 0 016.079 6.291v4.391a.673.673 0 01-.673.673h-2.64v2.339a.673.673 0 01-.673.673h-3.593v2.379a.673.673 0 01-1.077.538l-7.9-5.929H.677a.673.673 0 01-.673-.673v-4.391A6.305 6.305 0 016.08 9.276zm7.466-3.971a3.96 3.96 0 10-3.959 3.959 3.93 3.93 0 003.958-3.959zm-3.3 19.371V22.97a.672.672 0 01.673-.673h3.593V17.62h-3.593a.673.673 0 01-.673-.673V15.24l-6.29 4.717zm-8.9-5.391H2.61l7.905-5.928a.673.673 0 011.077.538v2.379h3.593a.672.672 0 01.673.673v2.338h1.967v-3.718a4.962 4.962 0 00-4.957-4.957H6.301a4.962 4.962 0 00-4.956 4.957z","fill":"#fff"}})])
          )
        }
      }
    